import React from 'react';

const FooterPublic = () => {
  return (
    <footer>
      <div className="footer-widgets-wrapper">
        <div className="container">
          <div className="column dt-sc-one-fourth first">
            <aside className="widget widget_text">
              <h3 className="widgettitle red_sketch"> Sobre a CreSer </h3>
              <p>Na <a><strong>CreSer</strong></a> você encontra os melhores profissionais para atender o seu bem mais precioso: sua família. Oferecemos:</p>
              <ul>
                <li> <a href="/#"> Psicoterapia individual para crianças e adolescentes </a> </li>
                <li> <a href="/#"> Orientação de pais </a> </li>
                <li> <a href="/#"> Avaliação neuropsicologica </a> </li>
                <li> <a href="/#"> Psicopedagogia </a> </li>
                <li> <a href="/#"> Pediatria </a> </li>
                <li> <a href="/#"> Nutrição </a> </li>
              </ul>
            </aside>
          </div>
          <div className="column dt-sc-one-fourth">
            <aside className="widget widget_recent_entries">
              <h3 className="widgettitle green_sketch"> Participações em poadcasts </h3>
              <ul>
                <li>
                  <a href="https://www.youtube.com/watch?v=tLQEWj1QsVc" target="_blank" rel="noreferrer">
                    <img style={{ border: 0 }} src="https://firebasestorage.googleapis.com/v0/b/psicologia-6d3e3.appspot.com/o/site%2Fimagens%2Ficones%2Fic-podcast.png?alt=media&token=25c302ef-9456-4d8d-9b77-4dfa010b0293" alt="" />
                  </a>
                  <h6><a href="/#"> CRIANÇA COM BIRRA: Causas e como lidar? </a></h6>
                  <span> Grow Podcast </span>
                </li>
                <li>
                  <a href="https://youtu.be/MBA683zIkrM?si=V7Pe3NQqeaGulIJP" target="_blank" rel="noreferrer">
                    <img style={{ border: 0 }} src="https://firebasestorage.googleapis.com/v0/b/psicologia-6d3e3.appspot.com/o/site%2Fimagens%2Ficones%2Fic-podcast.png?alt=media&token=25c302ef-9456-4d8d-9b77-4dfa010b0293" alt="" />
                  </a>
                  <h6><a href="https://youtu.be/MBA683zIkrM?si=V7Pe3NQqeaGulIJP" target="_blank" rel="noreferrer"> FAMÍLIAS EM CRISE: Tecnologia: amiga ou inimiga? </a></h6>
                  <span> Grow Podcast </span>
                </li>
                <li>
                  <a href="https://www.youtube.com/live/AMvFrNI1mGE" target="_blank" rel="noreferrer">
                    <img style={{ border: 0 }} src="https://firebasestorage.googleapis.com/v0/b/psicologia-6d3e3.appspot.com/o/site%2Fimagens%2Ficones%2Fic-podcast.png?alt=media&token=25c302ef-9456-4d8d-9b77-4dfa010b0293" alt="" />
                  </a>
                  <h6><a href="/#"> Psicóloga, especialista em crianças e adolescentes </a></h6>
                  <span> Grow Podcast </span>
                </li>
              </ul>
            </aside>
          </div>
          <div className="column dt-sc-one-fourth">
            <aside className="widget widget_recent_entries">
              <h3 className="widgettitle green_sketch"> Creser no Youtube </h3>
              <ul>
                <li>
                  <a href="https://www.youtube.com/live/zUNQWAvMPaA" target="_blank" rel="noreferrer">
                    <img style={{ border: 0 }} src="https://firebasestorage.googleapis.com/v0/b/psicologia-6d3e3.appspot.com/o/site%2Fimagens%2Ficones%2Fic-youtube.png?alt=media&token=c7e6d9ac-056b-444f-a837-79c4f69961c8" alt="" />
                  </a>
                  <h6><a href="/#"> BULLYING E TRAUMAS | Impactos e Soluções Familiares </a></h6>
                  <span> Grow PodCast </span>
                </li>
                <li>
                  <a href="https://www.youtube.com/live/0OKbrCZ-dLA" target="_blank" rel="noreferrer">
                    <img style={{ border: 0 }} src="https://firebasestorage.googleapis.com/v0/b/psicologia-6d3e3.appspot.com/o/site%2Fimagens%2Ficones%2Fic-youtube.png?alt=media&token=c7e6d9ac-056b-444f-a837-79c4f69961c8" alt="" />
                  </a>
                  <h6><a href="/#"> José Tadeu Nunes, Jessica Silvestre e Antônio Bernardo </a></h6>
                  <span> Podcast com Jair </span>
                </li>
              </ul>
            </aside>
          </div>
          <div className="column dt-sc-one-fourth">
            <aside className="widget widget_text">
              <h3 className="widgettitle steelblue_sketch">Contato</h3>
              <div className="textwidget">
                <p className="dt-sc-contact-info"><span className="fa fa-map-marker"></span> R. Benedito Leite, 52 - Vila Correa, Ferraz de Vasconcelos - SP </p>
                <p className="dt-sc-contact-info"><span className="fa fa-phone"></span> (11) 91913-9787 </p>
                <p className="dt-sc-contact-info"><span className="fa fa-envelope"></span><a href="mailto:clinicacrescerferraz@hotmail.com">clinicacrescerferraz@hotmail.com</a></p>
              </div>
            </aside>
          </div>
        </div>
      </div>

      <div className="copyright">
        <div className="container">
          <p className="copyright-info">© {new Date().getFullYear()} Clínica CreSer. Todos os direitos reservados.</p>
          <div className="footer-links"></div>
        </div>
      </div>
    </footer>
  );
};

export default FooterPublic;
